import React, { useEffect, useRef, useState } from "react";
import ArrowUpFillIcon from "../../../Custom-imeges/ArrowUpFillIcon";
import ArrowDownFillIcon from "../../../Custom-imeges/ArrowDownFillIcon";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  setCurrentWorkflowRunData,
  setGenerateingResponse,
  setSelectedWorkflowData,
  setUpdateWorkflowSelected,
  WorkflowsType,
} from "../../../store/one-query/workflowsSlice";
import { OverlayTrigger, Tooltip, TooltipProps } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import OptionsIcon from "../../../Custom-imeges/OptionsIcon";
import {
  useCreateWorkflow,
  useDeleteworkflow,
} from "../../../store/Apis/WorkflowsApi";
import DeleteModal from "../../main-page/components/get-conversation/DeletePopup";
import { Box, useMediaQuery } from "@mui/material";
import DuplicateWorkflow from "./DuplicateWorkflow";
import SignalRService from "../../one-query/services/SignalRService";
import { setFileError } from "../../../store/one-query/chatsSlice";
import {WorkflowType } from "../../../Helper";
import { getAppDetails } from "../../../Helpers/WorkflowHelper";
import { GetAppType } from "../../../Types/Workflow-Types";
interface Props {
  setSelectedWorkflow: (name: string) => void;
}
const WorkflowSidebarItems = ({ setSelectedWorkflow }: Props) => {
  const [showDuplicateWorkflow, setShowDuplicateWorkflow] = useState(false);
  const [workflowDuplicated, setWorkflowDuplicated] = useState<any>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [showDeleteOrEdit, setShowDeleteOrEdit] = useState<string | null>(null);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [isHoverItemId, setIsHoverItemId] = useState<string | null>(null);
  const { workflowId } = useParams<{ workflowId: string }>();
  const workflowsData = useAppSelector((s) => s.workflows.allWorkflows);
  const selectedWorkflow = useAppSelector(
    (s) => s.workflows.selectedWorkflowData
  );
  const isGeneratingResponse = useAppSelector(
    (s) => s.workflows.GenerateingResponse
  );
  const WorkflowImageAppSetting = useAppSelector(
    (s) => s.workflows.WorkflowImageAppSetting
  );
  const { CreateWorkflow, status: CreateWorkflowStatus } = useCreateWorkflow();
  const allTextSuitesApps = useAppSelector((s) => s.workflows.textSuitesApps);
  const deleteWorkflow = useDeleteworkflow();
  const responsiveSize = useMediaQuery("(max-width: 700px)");
  const [openWorkflow, setOpenWorkflow] = useState<string | null>(null);
  const handleOpenWorkflow = (workflowName: string) => {
    setSelectedWorkflow(workflowName);
  };

  const toggleShowWorkflows = (workflowName: string) => {
    setOpenWorkflow((prev) => (prev === workflowName ? null : workflowName));
  };

  const handleDeleteWorkflow = () => {
    deleteWorkflow(selectedWorkflow?.id);
    setShowDelete(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setShowDeleteOrEdit(null);
    }
  };

  useEffect(() => {
    if (showDeleteOrEdit) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDeleteOrEdit]);
  useEffect(() => {
    if (!isHoverItemId) setShowDeleteOrEdit(null);
  }, [isHoverItemId]);

  useEffect(() => {
    if (CreateWorkflowStatus === "success" && showDuplicateWorkflow)
      setShowDuplicateWorkflow(false);
  }, [CreateWorkflowStatus]),
    useEffect(() => {
      if (!isHoverItemId) setShowDeleteOrEdit(null);
    }, [isHoverItemId]);

  const handleEditWorkflow = (workflowData: WorkflowsType) => {
    dispatch(setUpdateWorkflowSelected(workflowData));
    dispatch(setCurrentWorkflowRunData({runId:""}))
    navigate(`/workflows/edit/${workflowData.id}`);
  };

  const handleDelete = (item: any) => {
    setShowDelete(true);
    setShowDeleteOrEdit(null);
    dispatch(setSelectedWorkflowData(item));
  };
  const handleDuplicateWorkflow = (item: any) => {
    setShowDuplicateWorkflow(true);
    setWorkflowDuplicated({ ...item });
  };
 const handleSaveWorkflow = async (workflowName: string) => {
  const connectionId = await SignalRService.getInstance().getConnectionId();

  const formData = new FormData();
  formData.append("name", workflowName);
  formData.append("connectionId", connectionId);

  const apps = workflowDuplicated?.apps
    ?.map((item: any, index: number) => {
      const matchedApp = allTextSuitesApps.find(
        (app) => app.appType === item.appType
      );

      return matchedApp
        ? {
            appId: matchedApp.id,
            payload: getAppDetails(item,WorkflowImageAppSetting),
            appOrder: (index + 1).toString(),
          }
        : null;
    })
    .filter(Boolean) as {
    appId: string;
    payload: string;
    appOrder: string;
  }[];

  apps.forEach((app, index) => {
    formData.append(`apps[${index}].appId`, app.appId);
    formData.append(`apps[${index}].payload`, app.payload);
    formData.append(`apps[${index}].appOrder`, app.appOrder);
  });

  if (workflowName.trim().length === 0) {
    dispatch(
      setFileError({
        isError: true,
        errorMsg: "Cannot save: Workflow name is required.",
        reason: "user upload file type not support",
      })
    );
  } else {
    CreateWorkflow(formData);
  }
};

  const handleSaveDuplicateWorkflow = (workflowName: string) => {
    handleSaveWorkflow(workflowName);
  };

  const renderTooltip =
    (tooltipText: string | undefined) => (props: TooltipProps) => {
      return tooltipText !== "" ? (
        <Tooltip
          className="history-item-tooltip"
          id="dropdown-item-tooltip"
          {...props}
        >
          <span className="persona-item-overlay">{tooltipText}</span>
        </Tooltip>
      ) : (
        <div></div>
      );
  };
  
  useEffect(() => {
    if (workflowId === undefined || selectedWorkflow.id !== workflowId) dispatch(setGenerateingResponse(false));
  },[workflowId])

  return (
    <div className="w-100 d-flex flex-column workflowsText">
      {workflowsData?.map((item) => (
        <div className="">
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 300 }}
            overlay={renderTooltip(item?.name)}
          >
            <div
              className={`d-flex align-items-center justify-content-between conatiner-workflows ${
                item?.id === workflowId && "selected"
              }`}
              onMouseEnter={() => setIsHoverItemId(item?.id)}
              onMouseLeave={() => setIsHoverItemId("")}
              style={{
                pointerEvents:
                  item?.id !== workflowId && isGeneratingResponse
                    ? "none"
                    : "auto",
                opacity:
                  item?.id !== workflowId && isGeneratingResponse ? 0.5 : 1,
              }}
            >
              <div
                className="workflow-name"
                onClick={() => handleOpenWorkflow(item?.name)}
              >
                <span
                  className="me-2"
                  onClick={(e) => {
                    e.stopPropagation()
                    toggleShowWorkflows(item?.name)
                  }}
                >
                  {openWorkflow === item?.name ? (
                    <ArrowUpFillIcon className="custom-icon" />
                  ) : (
                    <ArrowDownFillIcon className="custom-icon" />
                  )}
                </span>
                {item?.name}
              </div>
              <div className="position-relative">
                {isHoverItemId === item?.id || responsiveSize ? (
                  <div onClick={() => setShowDeleteOrEdit(item?.id)}>
                    <OptionsIcon />
                  </div>
                ) : null}
                {showDeleteOrEdit === item?.id && (
                  <div className="EditOrDeleteMenuWorkflow" ref={dropdownRef}>
                  {item.workflowType===WorkflowType.User&&(
                    <p
                      className="mb-0"
                      onClick={() => handleEditWorkflow(item)}
                    >
                      Edit
                    </p>
                  )}
                    <p
                      className="mb-0"
                      onClick={() => handleDuplicateWorkflow(item)}
                    >
                      Duplicate
                    </p>
                    {item.workflowType===WorkflowType.User&&(
                     <p className="mb-0" onClick={() => handleDelete(item)}>
                      Delete
                    </p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </OverlayTrigger>
          <div
            className="workflows-details"
            style={{
              display: openWorkflow === item?.name ? "block" : "none",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                left: "13px",
                top: "0px",
                height: item?.apps?.length === 0 ? "62%" : "100%",
                opacity: " 0.4",
                borderLeft: "1px dotted var(--Main_icons_color)",
              }}
            />
            <ul className="workflow-list">
              {item?.apps?.map((app) => (
                <li
                  className="workflow-list-item"
                  style={{
                    fontSize:
                      app?.appType === "Prompt Generator" ? "11px" : "12px",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      left: "-8px",
                      width: "8%",
                      top: "48%",
                      opacity: "0.4",
                      borderBottom: "1px dotted var(--Main_icons_color)",
                    }}
                  />
                  {GetAppType(app.appType)} - {app?.appType}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
      <DeleteModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
        method={handleDeleteWorkflow}
        name="Delete workflow"
        message={`Are you sure to delete "${selectedWorkflow?.name}"?`}
        deleteWorkflow={true}
      />
      {showDuplicateWorkflow && (
        <DuplicateWorkflow
          show={showDuplicateWorkflow}
          handleClose={() => setShowDuplicateWorkflow(false)}
          method={handleSaveDuplicateWorkflow}
          workflowNameParent={workflowDuplicated?.name}
        />
      )}
    </div>
  );
};

export default WorkflowSidebarItems;
